import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
     Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL; 
    // Vue.axios.defaults.baseURL = "https://portalpagosdev.difarma.cl/api/";//"http://localhost:62663"; //http://localhost:62663"; //"https://portalpagos.socofar.com/api/";//"https://portalpagosdev.difarma.cl/api/"
    // Vue.axios.defaults.baseURL = "https://portalpagos.socofar.com/api/";//"https://portalpagosdev.difarma.cl/api/"
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  query(resource, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.get(resource.action, params).catch(error => {
      // console.log(error);
      throw error;//new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.get(`${resource.action}/${slug}`).catch(error => {
      // console.log(error);
      throw error;// new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.post(`${resource.action}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.put(`${resource.action}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.put(`${resource.action}`, params);
  },

     /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  patch(resource, slug, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.patch(`${resource.action}/${slug}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.delete(resource.action).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
